<template>
  <info-dialog-template
    v-model="isShownDialog"
    :title="$t('safe.deal.challenge.processing.title')"
    @click="handleClose"
  >
    <div :class="$style.container">
      <template v-if="hasDispute">
        <p>{{ $t('safe.deal.dispute.with.description') }}</p>
        <p><i>{{ $t(displayDisputeReason) }}</i></p>
      </template>
      <template v-else>
        <p>{{ $t('safe.deal.dispute.without.description') }}</p>
      </template>
      <p>{{ $t('safe.deal.dispute.information') }}</p>
      <p v-html="displayAmountReturn"></p>
      <p v-html="displayPayoutNotAvailable"></p>
    </div>
    <div slot="footer" :class="$style.footer">
      <div :class="$style.action">
        <link-button
          v-if="isProtestButton"
          href="https://help.capusta.space/protest"
          target="_blank"
        >
          {{ $t('safe.deal.protest.button') }}
        </link-button>
        <simple-button v-else @click="handleResolve">
          {{ $t('safe.deal.closed.dispute.button') }}
        </simple-button>
      </div>
      <div :class="$style.action">
        <simple-button variant="transparent" @click="$emit('refund')">
          {{ $t('safe.deal.refund.button') }}
        </simple-button>
      </div>
    </div>
  </info-dialog-template>
</template>

<script>
import { mapMutations } from 'vuex';
import dialogMixin from 'lib/mixins/dialogMixin';
import { formatDateToCustomDateFormat } from 'lib/utils/date';

import HTTPService from '@/services/Http';

import LinkButton from 'molecules/common/LinkButton';
import SimpleButton from 'molecules/common/SimpleButton';
import InfoDialogTemplate from 'templates/InfoDialogTemplate';

export default {
  name: 'SafeDealChallengeProcessingStatusDialog',
  mixins: [
    dialogMixin,
  ],
  components: {
    LinkButton,
    SimpleButton,
    InfoDialogTemplate,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayAmountReturn() {
      return this.$t('safe.deal.amount.return', {
        date: this.formattedDealExpireDate,
        startTag: '<strong>',
        endTag: '</strong>',
      });
    },
    displayPayoutNotAvailable() {
      return this.$t('safe.deal.payout.not.available', {
        startTag: '<span style="color: var(--color-red)">',
        endTag: '</span>',
      });
    },
    dispute() {
      return this.deal.dispute;
    },
    hasDispute() {
      if (this.$validate.isUndefined(this.dispute)) {
        return false;
      }

      if (this.$validate.isNull(this.dispute)) {
        return false;
      }

      return true;
    },
    formattedDealExpireDate() {
      const { expireDate } = this.deal;

      if (this.$validate.isUndefined(expireDate) || this.$validate.isNull(expireDate)) {
        return '';
      }

      return formatDateToCustomDateFormat(expireDate, 'D.MM.YYYY');
    },
    displayDisputeReason() {
      if (!this.hasDispute) {
        return '';
      }

      return this.dispute.reason;
    },
    isProtestButton() {
      if (!this.hasDispute) {
        return false;
      }

      return this.dispute.status === 'REOPENED';
    },
  },
  methods: {
    async handleResolve() {
      const requestData = {
        ...this.deal,
        dispute: null,
      };

      try {
        const { data } = await HTTPService.dealDisputeResolve(requestData);
        this.CHANGE_SELECTED_TRANSACTION_DEAL(data);

        this.isShownDialog = false;
        await this.$nextTick;

        this.$alert({
          type: 'success',
          text: this.$t('safe.deal.confirm.dispute.resolve'),
        });
      } catch (error) {
        console.error(error);

        this.$alert({
          type: 'warning',
          text: 'error.in.system',
        });
      }
    },
    ...mapMutations(['CHANGE_SELECTED_TRANSACTION_DEAL']),
  },
};
</script>

<style lang="sass" module>
  .container
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff

    p
      opacity: .75

      &:not(:last-child)
        margin-bottom: 20px

    strong
      font-weight: 700

  .footer
    margin-top: 20px
    display: flex
    flex-direction: column

    +respond-to(small)
      flex-direction: row
      justify-content: space-between

  .action
    flex-grow: 1
    overflow: hidden

    &:not(:last-child)
      margin: 0 0 20px

    +respond-to(small)
      &:not(:last-child)
        margin: 0 20px 0 0

  .submit
    min-width: 230px
</style>
